export default __webpack_public_path__ + "static/media/gra.ca591f5c.png";